import { type MachineType } from "@packsize/schemas/machines";

import { packNetAxios } from "@/lib/api-client";
import { type AuditRecord } from "@/components/diff-view";
import { machineAuditTypes } from "@/constants/machine-audit-types";
import { configurationAuditHistorySchema } from "@/schemas/audit/configuration-audit";

import { baseRoutes } from "./base-routes";

export const getMachineConfigurationHistory = async (machineType: MachineType, id: string): Promise<AuditRecord[]> => {
	const auditType = machineAuditTypes[machineType];

	if (auditType === undefined) {
		throw new Error(`Configuration audit history is not available for machine type "${machineType}".`);
	}

	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/${auditType}/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getMachineConfigurationHistory" })
		.parseWithTelemetry(response.data)
		.map((auditRecord) => ({ ...auditRecord, defaultExpanded: false }));
};

export const getPickZoneConfigurationHistory = async (id: string): Promise<AuditRecord[]> => {
	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/PickZone/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getPickZoneConfigurationHistory" })
		.parseWithTelemetry(response.data)
		.map((a) => ({ ...a, defaultExpanded: false }));
};

export const getMachineGroupConfigurationHistory = async (id: string): Promise<AuditRecord[]> => {
	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/MachineGroup/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getMachineGroupConfigurationHistory" })
		.parseWithTelemetry(response.data)
		.map((a) => ({ ...a, defaultExpanded: false }));
};

export const getCartonPropertyGroupConfigurationHistory = async (id: string): Promise<AuditRecord[]> => {
	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/CartonPropertyGroup/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getCartonPropertyGroupConfigurationHistory" })
		.parseWithTelemetry(response.data)
		.map((a) => ({ ...a, defaultExpanded: false }));
};

export const getCorrugateConfigurationHistory = async (id: string): Promise<AuditRecord[]> => {
	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/Corrugate/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getCorrugateConfigurationHistory" })
		.parseWithTelemetry(response.data)
		.map((a) => ({ ...a, defaultExpanded: false }));
};

export const getLabelTemplateHistory = async (id: string): Promise<AuditRecord[]> => {
	const response = await packNetAxios.get(`${baseRoutes.audit}/v1/ConfigurationAudit/PrintTemplate/${id}`);

	return configurationAuditHistorySchema
		.enrich({ callSite: "getLabelTemplateHistory" })
		.parseWithTelemetry(response.data)
		.map((a) => ({ ...a, defaultExpanded: false }));
};
